import React, { useEffect } from "react";
import "./products.css";

import ReactPlayer from "react-player";

import Custom1 from "../../assets/images/products/custom1.jpg";
import Custom2 from "../../assets/images/products/custom2.jpg";
import Custom3 from "../../assets/images/products/custom3.jpg";
import Custom4 from "../../assets/images/products/custom4.jpg";

import AOS from "aos";
import "aos/dist/aos.css";

const CCD = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
  }, []);
  return (
    <>
      <div className="products-banner ccd">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="content">
            <div className="heading" data-aos="fade-up" data-aos-duration="1500">
              <div className="heading-flex">
                <h2>Custom Course Development</h2>
                <h4>
                  Upskill, transform and motivate your workforce, with custom
                  E-learning courses specially designed and developed for your
                  workforce.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="products-section">
        <div className="products-banner-circle"></div>
        <div className="products-section-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-right" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Personalized Learning Paths</h2>
                    <p>
                      Discover personalized learning paths curated to suit your
                      individual needs. Easily acquire new skills efficiently
                      through our intuitive dashboard, which helps you find the
                      most relevant courses and resources aligned with your
                      goals.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="player" data-aos="fade-left" data-aos-duration="1500">
                  <img src={Custom1} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content-reverse">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5">
                <div className="player" data-aos="fade-right" data-aos-duration="1500">
                  <img src={Custom2} alt="" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-left" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Interactive Content</h2>
                    <p>
                      Explore our interactive content feature designed to
                      enhance your learning experience. Benefit from visual
                      aids, audio lectures, and real-world examples that
                      facilitate better understanding of complex topics. Assess
                      your knowledge and track your progress through interactive
                      quizzes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-right" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Secure Platform</h2>
                    <p>
                      Rest assured, your data is in safe hands on our platform.
                      We employ cutting-edge security measures to safeguard your
                      information, with encrypted servers ensuring its
                      protection against any potential threats.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="player" data-aos="fade-left" data-aos-duration="1500">
                  <img src={Custom3} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="products-section-content-reverse">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5">
                <div className="player" data-aos="fade-right" data-aos-duration="1500">
                  <img src={Custom4} alt="" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="products-main" data-aos="fade-left" data-aos-duration="1500">
                  <div className="products-main-content">
                    <h2>Mobile friendly</h2>
                    <p>
                      Our platform prioritizes mobile users, ensuring easy
                      access anytime, anywhere. With our mobile apps, staying
                      connected and learning on the go is effortless.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CCD;
